export default __webpack_public_path__ + "static/media/Common Ring Dove.3fb9ba1e.jpg";